<span class="text{{weight ? ' -weight-'+weight : ''}}"
    [ngClass]="{'-dimmed': dimmed, '-underline': underline, '-brand-accent': brandAccent, '-emphasis': emphasis, '-smaller': smaller && !bigger, '-bigger': bigger && !smaller}">
    <ng-content></ng-content>
</span>